import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_luxe_gifting: FaireThemeEntity = {
  token: "discovery_theme_luxe-gifting",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Luxe Gifting Over $100",
  description: "Premium gifts for special occasions",
  bgColor: "#E8D8E8",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
